import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from '../../../../services/auth.service';
import * as moment from "moment-timezone";
const emails = require("../../../../services/emails.json");

@Component({
  selector: 'form-plan',
  templateUrl: './plan.component.html',
  styleUrls: ['./plan.component.scss']
})
export class FormPlanComponent implements OnInit {
  showAddPlanForm: boolean = false;
  isCompleted: boolean = false;
  currentPlan: any;
  currentPlanIndex: number = 0;

  @Input() plans: any[];

  constructor(public auth: AuthService) {}

  ngOnInit() {
    this.showAddPlanForm = false;
    this.currentPlan = undefined
    this.currentPlanIndex = -1
  }

  addPlan() {
    this.currentPlanIndex = -1;
    this.currentPlan = undefined;
    this.showAddPlanForm = true;
    window.scrollTo(0, 0);
  }

  edit(plan, index) {
    this.currentPlan = Object.assign({}, plan)
    delete this.currentPlan.change
    delete this.currentPlan.delete

    this.currentPlanIndex = index
    this.showAddPlanForm = true;

    window.scrollTo(0, 0);
  }

  delete() {
    if (this.currentPlanIndex < 0) return;
    this.plans = this.plans.map((item, index) => {
      if (index === this.currentPlanIndex) {
        if (this.auth.user.status === AuthService.VTUBER_COMPLETD_STATUS) {
          let supporters = this.currentSupporters(item.uid);
          if (supporters.length > 0) {
            let today = moment().tz('Asia/Tokyo');
            let futureMonth = moment(today).tz('Asia/Tokyo').add(1, 'M');

            item.delete = {
              deleteAt: futureMonth.format("Y-MM")
            }

            supporters.map(userID => {
              this.sendDeleteEmail(userID, item)
            })
          } else {
            return undefined;
          }
        } else {
          return undefined;
        }
      }
      return item;
    }).filter(item => item !== undefined)

    this.updatePlans(false)
  }

  currentSupporters(uid) {
    let supporters = []
    if (this.auth.user.supporters && this.auth.user.supporters.length > 0) {
      this.auth.user.supporters.map(item => {
        if (item.plan_uid === uid) supporters.push(item.user_id);
      })
    }

    return supporters
  }

  getCurrentSupporters(planID) {
    if (this.auth.user.supporters === undefined) return 0;
    return this.auth.user.supporters.filter(item => item.plan_uid === planID && (item.stoppedAt === undefined || item.stoppedAt > Date.now())).length;
  }

  save(inputs: any) {
    if (inputs.isNew) { // New Plan
      delete inputs.isNew;
      delete inputs.deletedAt;
      delete inputs.olds;
      delete inputs.delete;

      if (this.auth.user.status === AuthService.VTUBER_COMPLETD_STATUS) {
        inputs.status = 'draft'
      }
      this.plans.push(Object.assign({uid: ("000000" + Math.floor(Math.random() * 100000)).slice(-6) }, inputs));
    } else { // Edit Plan
      delete inputs.isNew;
      delete inputs.deletedAt;
      delete inputs.olds;
      delete inputs.delete;

      this.plans = this.plans.map((item, index) => {
        if (index === this.currentPlanIndex) {
          if (this.auth.user.status === AuthService.VTUBER_COMPLETD_STATUS) {
            if (item.status && item.status === 'draft') {
              item = Object.assign({}, inputs)
              item.status = 'draft'
            } else {
              item.change = Object.assign({}, inputs)
            }
          } else {
            item = Object.assign({}, inputs)
          }
        }
        return item
      })
    }

    this.updatePlans(true)
  }

  changeStatusLabel(plan) {
    if (plan.status === 'review') return '(申請中)'
    if (plan.status === 'approve') return '(承認済み)'
    if (plan.status === 'reject') return '(承認不可)'
    if (plan.status === undefined) return '(未送信)'

    return ''
  }

  planStatusLabel(plan) {
    if (plan.status === 'draft') return '(未送信)'
    if (plan.status === 'review') return '(申請中)'
    if (plan.status === 'reject') return '(承認不可)';

    return ''
  }

  sendDeleteEmail(userId, plan) {
    this.auth.getUserByUid(userId).subscribe(res => {
      if (res && res.length > 0) {
        let user: any = res[0]

        this.auth.sendEmail({
          to: user.email,
          subject: emails.plan_delete_subject,
          text: this.auth.getEmailTemplate(emails.plan_delete.join("")).replace(/\[ユーザー名\]/g, user.displayName)
                              .replace(/\[VTuber名\]/g, this.auth.user.displayName)
                              .replace(/\[支援プランタイトル\]/g, plan.title)
                              .replace(/\[支援金額\/月\]/g, plan.amount + "円/月")
                              .replace(/\[通話時間\/月\]/g, plan.period + "分/月")
                              .replace(/\[対象VTuberの支援ページのID\]/g, "support/" + this.auth.user.uid)
                              .replace(/\[〇月〇日\]/g, plan.delete.deleteAt.replace("-", "年") + "月01日")
        })
      }
    })
  }

  formatChangeDate(date) {
    return date.replace("-", "年") + "月01日"
  }

  updatePlans(merge) {
    let params = {
      uid: this.auth.user.uid,
      plans: this.plans,
      planIDs: this.plans.map(item => item.uid)
    }

    if (merge === false) { // Delete
      params = this.auth.user
      params.plans = this.plans
      params.planIDs = this.plans.map(item => item.uid)
    }

    this.auth.updateUserData(params, merge)
    .then(() => {
      this.auth.fetchUser();
      this.isCompleted = true;
      this.showAddPlanForm = false;
      this.currentPlanIndex = -1;
      this.currentPlanIndex = undefined

      let self = this
      setTimeout(function() {
        self.isCompleted = false;
      }, 3000);
    })
  }
}
